<header>
  <div class="fixed-top bg-light">
    <a class="navbar-brand" style="margin-left: 2rem" routerLink="/">
      <img src="assets/images/siemens-logo.svg" width="89" height="15" alt="Siemens" class="ml-2 mt-4">
    </a>
  <nav class="navbar  navbar-expand-lg navbar-light bg-light px-2">
    <div class="container-fluid">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item nav-head">
            <a class="nav-link text-dark">
              <span class="text-head"><strong>SiePro</strong></span>
              <span class="text-small">Siemens procurement</span>
              <span class="text-small" id="userRole">{{userRole}}</span>
            </a>
          </li>
          <li class="nav-item align-self-center" *ngIf="accessType !== 'MODULE_ACCESS'">
            <a class="nav-link text-normal" [routerLink]="getHomeLink()" routerLinkActive="active" (click)="setActiveTab('home')">
              <span>Home</span>
              <span *ngIf="activeTab == 'home'" class="nav-border"></span>
            </a>
          </li>
          <li class="nav-item align-self-center" *ngIf="userRole.toLowerCase() !== 'ehs_manager' && userRole.toLowerCase() !== 'po_buyer' && userRole.toLowerCase() !== 'factory_procurement' && accessType !== 'MODULE_ACCESS'">
            <a class="nav-link text-normal" routerLink="/dashboard/dashboard-charts" routerLinkActive="active" (click)="setActiveTab('dashboard')">
              <span>Dashboard</span>
              <span *ngIf="activeTab == 'dashboard'" class="nav-border"></span>
            </a>
          </li>
        </ul>
        <div class="d-flex">
          <!-- <li class="nav-item align-self-center">
            <a class="nav-link text-normal" routerLink="/dashboard" routerLinkActive="active">
              <span>Home</span>
              <span class="nav-border"></span>
            </a>
          </li> -->
          <li class="nav-item align-self-center">
            <a class="nav-link text-dark d-flex">
              <img src="{{defaultProfile}}+{{userDetails?.user_name || userDetails?.name}}" alt="Picture" width="30" height="30" class="me-2">
              <div class="d-flex flex-column">
                <span class="align-self-center text-small mb-1"><strong>{{userDetails?.user_name || userDetails?.name}}</strong></span>
                <span class="text-small text-capitalize">
                  <ng-container *ngIf="userRole !== 'PO_BUYER'">
                    {{userRole?.toLowerCase()}}
                  </ng-container>
                  <ng-container *ngIf="userRole === 'PO_BUYER'">
                    PO confirmation & follow-up
                  </ng-container>
                </span>
              </div>
            </a>
          </li>
          <li class="nav-item align-self-center">
            <a class="nav-link text-dark cursor-pointer" title="Log Out" (click)="logOut()">
              <span class="fa fa-power-off"></span>
            </a>
          </li>
        </div>
      </div>
    </div>
  </nav>
</div>
</header>

<div class="app-body">
  <!-- <aside>
    <section class="mt-4 ps sidebar-nav">
      <ul class="list-unstyled">
        <li class="nav-item" *ngFor="let nav of navItems">
          <a class="nav-link cursor-pointer" routerLink="{{nav?.route}}" routerLinkActive="active">
            <span class="nav-icon fa pe-1" [ngClass]="nav.icon">
            </span>
            {{nav?.name}}
          </a>
        </li>
      </ul>
    </section>
  </aside> -->
  <main class="main w-100">
    <div class="container-fluid">
      <div class="content-page">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
</div>